import React from 'react';
import * as PropTypes from 'prop-types';

const RecapCredit = (props) => {
  var TotalIsZero = props.credit >= props.cartTotal;
  var providerLabel = props.providerLabel ? props.providerLabel : 'Welfare';
  return (
    <div className="order-recap__meta">
      <div className='divider'></div>
      <div className="meta">
        <div className="meta__key">
          <h6 className='meta__key__title'><strong>Budget {providerLabel}</strong></h6>
        </div>
        {TotalIsZero ? (
          <div>
            <div className="meta__value">
              <p className="meta__value__text">{app_main_wpml.current_points}</p>
              <h6 className='meta__key__title'><strong>{props.credit} {app_main_wpml.points}</strong></h6>
            </div>
          </div>
        ) : (
          <div>
            <div className="meta__value">
              <p className="meta__value__text">{app_main_wpml.current_points}</p>
              <h6 className='meta__key__title'><strong>{props.credit} {app_main_wpml.points}</strong></h6>
            </div>
            <div className="meta__value">
              <p className="meta__value__text">{app_main_wpml.required_points}</p>
              <h6 className='meta__key__title'><strong>{props.cartTotal} {app_main_wpml.points}</strong></h6>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
RecapCredit.propTypes = {
  cartTotal: PropTypes.number,
  credit: PropTypes.number,
  providerLabel: PropTypes.string,
};

export default RecapCredit;
export { RecapCredit };
